package com.exura.features.userprofile.domain.repository

import com.exura.features.firebase.domain.repository.PrefixedRepository
import com.exura.features.userprofile.domain.model.UserSettingsBase

interface UserSettingsRepository<T : UserSettingsBase> : PrefixedRepository<T, T> {
    suspend fun getSettings(settingsName: String): Result<T?> =
        read(id = settingsName)

    suspend fun saveSettings(settingsName: String, settings: T): Result<T> =
        set(settings, settingsName)
}
